export enum SupplierSubscriptionPlan {
    BASIC = 'BASIC',
    PROFESSIONAL = 'PROFESSIONAL',
    ENTERPRISE = 'ENTERPRISE',
}

export interface SupplierGroupSubscriptionMessage {
    supplierGroupId: string;
    plan: SupplierSubscriptionPlan;
    transactionFeePercentage?: number;
    dateSubscriptionSignup?: number;
    subscriptionSignupUserId?: string;
    dateSubscriptionRenewal?: number;
}
